import { MappingUser } from '@ni/nimble-components/dist/esm/mapping/user';
import { wrap } from '../../utilities/react-wrapper';

export { type MappingUser };
export const NimbleMappingUser = wrap(MappingUser);
